<template>
    <b-container class="mt-2">
        <div class="d-flex">
            <b-btn
                    v-if="mode === 'lg'"
                    variant="link"
                    @click="$emit('cancel')"
            >
                <i class="fas fa-chevron-left"/>
                Retour à la liste des conversations
            </b-btn>
        </div>
        <user-add
                v-if="users.length > 0"
                :users="users"
                :multiple="multiple"
                @change="change($event)"
        />
        <b-btn
                v-if="multiple"
                variant="primary"
                block
                :disabled="usersSelected.length === 0"
                @click="create(usersSelected)"
        >
            <template v-if="mode === 'lg'">
                Commencer la conversation
            </template>
            <template v-else>
                Partager la séance type
            </template>
        </b-btn>
    </b-container>
</template>
<script>
    import UserAdd from "../user/Add";

    export default {
        name: 'thread-new',
        components: {UserAdd},
        props: {
            multiple: {
                type: Boolean,
                default: false
            },
            users: Array,
            threadType: Object,
            mode: {
                default: 'lg',
                type: String
            }
        },
        data: () => ({
            usersSelected: []
        }),
        methods: {
            change(users) {
                this.multiple ? this.usersSelected = users : this.create(users)
            },
            async create(users) {
                const {threadId} = await this.$store.dispatch('base/thread/new', {
                    threadTypeId: this.threadType.id,
                    users
                })
                this.$emit('new', threadId)
            }
        }
    }
</script>
